<app-titledescription [title]="'Modalidades'" [description]="'En esta seccion podra ver el listado de modalidades'"></app-titledescription>
<app-button [text]="'Agregar modalidad'"></app-button>
<app-table></app-table>
